import { render, staticRenderFns } from "./CustomerEngagementAllocation.vue?vue&type=template&id=caae8448&scoped=true&"
import script from "./CustomerEngagementAllocation.vue?vue&type=script&lang=js&"
export * from "./CustomerEngagementAllocation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEngagementAllocation.vue?vue&type=style&index=0&id=caae8448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caae8448",
  null
  
)

export default component.exports